<template>
  <div>
    <div class="content index-content">
      <!-- banner begin -->
      <!-- Swiper -->
      <div class="swiper-container banner">
        <div class="swiper-wrapper">
          <div class="swiper-slide bg-cover broadcast" v-if="recommend" v-for="item in recommend"
               :attr-item="JSON.stringify({url: item.url, item_id:item.item_id,img_path_h5: item.img_path_h5,type: item.activity_mini.type})" attr-type="recommend">
            <img :src="item.img_path_h5"/>
            <a href="javascript:void(0);"></a>
          </div>
        </div>
       
        <div class="swiper-pagination" style="height: 10px"></div>
      </div>
      <!-- banner end -->

      <div class="id-content-inner">

        <!--h5 class="show-title" v-if="videosName"><em class="icon-d"></em>作品展播</h5>

        <div class="show-box" v-if="videosName">
          <div class="swiper-container show-work">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(v,ind) in videosName">
                <ul class="show-list">
                  <router-link tag="li" v-for="(val,i) in twoNumbers" v-if="beSelected[ind*2+i]"
                               :to="{name:'VideoName',params: {id: beSelected[ind*2+i].activity_id, uuid: beSelected[ind*2+i].file_id, type: beSelected[ind*2+i].file_type}}">
                    <a href="javascript:void(0);">
                      <div class="pic-box">
                        <img v-if="beSelected[ind*2+i]" :src="beSelected[ind*2+i].file.thumb_url+'?p=3&o=2&w=350&h=197'" alt=""/>
                        <img v-else src="" alt=""/>
                        <i class="icon-time" v-if="beSelected[ind*2+i].file_type == 'video'">
                          {{beSelected[ind*2+i].file.time_span|formatSeconds}}
                        </i>
                      </div>
                      <p style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;height: 20px">
                        {{beSelected[ind*2+i].file.title}}</p>
                    </a>
                    <a href="javascript:void(0);">
                      <p class="pic-linktit">{{beSelected[ind*2+i].activity_mini.title}}</p>
                    </a>
                  </router-link>
                </ul>
              </div>
            </div>
          </div>
        </div-->

        <!--h5 class="show-title" v-if="tablesName"><em class="icon-newshow"></em>最新征集</h5>
        <NewestTpl :tables="tables" :tablesName="tablesName"></NewestTpl-->

        <!--h5 class="show-title"><em class="icon-onshow"></em>正在进行</h5-->
        <ul class="id-link" v-if="underway.length > 0" style="padding: 10px 10px 0px 10px">
          <li v-for="(item,ind) in underway">
            <a href="javascript:void(0);" @click="fiery(item.url,item.id,item.img_path_h5,item.type)">
              <!-- <router-link  tag="a" :to="{name:'Detail',params: {id:item.activity_mini.id}}">-->
              <div class="linkpic-box">
                <img v-if="item.img_path_h5" v-lazy="item.img_path_h5+'?p=3&o=2&w=710&h=399'">
                <!--em class="hot"></em-->
              </div>
              <div class="link-title">
                <div class="link-time" v-if="item.end_time != ''"><em class="icon-time"></em>{{item.end_time,item.start_time|orderBy}}
                </div>
                <div class="link-time" v-else><em class="icon-time"></em>永久有效</div>
                <p><em class="icon-card" v-if="item.type == 1"></em>{{item.item_title}}</p>
              </div>
              <!--</router-link>-->
            </a>
          </li>
        </ul>

        <ul class="id-link" id="indexUl" v-if="underway2.length > 0" style="padding: 0 10px 10px 10px">
          <li v-for="(item,ind) in underway2">
            <a href="javascript:void(0);"
               @click="fiery(item.url,item.id,JSON.parse(item.playbill).playbill_big_h5,item.type)">
              <!-- <router-link  tag="a" :to="{name:'Detail',params: {id:item.activity_mini.id}}">-->
              <div class="linkpic-box">
                <img v-if="item.playbill" v-lazy="JSON.parse(item.playbill).playbill_big_h5+'?p=3&o=2&w=710&h=399'">
              </div>
              <div class="link-title">
                <div class="link-time" v-if="item.end_time != ''"><em class="icon-time"></em>
                  {{item.end_time,item.start_time|orderBy}}
                </div>
                <div class="link-time" v-else><em class="icon-time"></em>永久有效</div>
                <p><em class="icon-card" v-if="item.type == 1"></em>{{item.title}}</p>
              </div>
              <!--  </router-link>-->
            </a>
          </li>
        </ul>
        <div v-if="underway2.length == 0 && underway.length == 0"
             style="text-align: center;line-height: 30px; font-size: 14px;color: #999">暂无数据
        </div>
        <!--
        <router-link tag="a" class="id-more-mess" to="/find">
          <div class="btn-click-entry">查看全部</div>
        </router-link>
        -->
      </div>
    </div>
  </div>
</template>

<script>
  import newestTpl from '../template/newestTpl.vue';

  export default {
    data() {
      return {
        tables: '',     // 首页最新征集
        tablesName: '', // 首页最新征集数量
        recommend: '',  // 首页轮播
        beSelected: '', // 作品展播
        videosName: '', // 作品展播
        twoNumbers: 2,  // 轮播个数
        underway: [],   // 正在进行
        underway2: [],
        fileItem: null,
        tops: '0',
        data: ''
      }
    },
    methods: {
      fiery(type, id, route, customized) { // 操作按钮事件
        var hrefHTML = this.hrefHTML(type, id)
        if (customized == 2 || customized == 1) {
          if (hrefHTML) {
            window.location.href = hrefHTML
          } else {
            this.$router.push({name: 'Detail', params: {id: id}});
          }
        } else {
          if (hrefHTML) {
            window.location.href = hrefHTML
          } else {
            if (type == 2) {
              this.$router.push({name: 'Notice', params: {id: id}});
            } else if (type == 3) {
              this.$router.push({name: 'list_vote', params: {id: id, active: 1}});
            } else {
              this.$router.push({name: 'Detail', params: {id: id}});
            }
          }
        }
      },
      detail(type, id, route, customized) { // 跳转详情页面
        var hrefHTML = this.hrefHTML(type, id)
        if (customized == 2 || customized == 1) {
          if (hrefHTML) {
            window.location.href = hrefHTML
          } else {
            this.$router.push({name: 'Detail', params: {id: id}});
          }
        } else {
          if (hrefHTML) {
            window.location.href = hrefHTML
          } else {
            if (type == 2) {
              this.$router.push({name: 'Notice', params: {id: id}});
            } else if (type == 3) {
              this.$router.push({name: 'list_vote', params: {id: id, active: 1}});
            } else {
              this.$router.push({name: 'Detail', params: {id: id}});
            }
          }
        }
      },
      linkpic() { // 图片尺寸
        var linkpic = Math.ceil($('.linkpic-box').width() / 2);
        $('.linkpic-box').find('img').css('height', linkpic);

        // banner图片尺寸控制 2:1
        var bannerpic = Math.ceil($('.banner').width() / 2);
        $('.banner').find('img').css('height', bannerpic);

        // 图片尺寸控制 16:9
        var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
        $('.pic-box').find('img').css({height: picHimg, visibility: 'visible'});
      }
    },
    components: {   // 渲染页面
      NewestTpl: newestTpl
    },
    created: function () {
      // 首页轮播
      var that = this;
      $('.id-nav-recom').eq(0).addClass('nav-on').siblings().removeClass('nav-on');
      var Recommend = {
        activity_id: '0',
        type: 'indexpic',
        pagesize: '6',
        page: 1
      };
      this.$http.get(API.GetRecommend, {params: Recommend})
        .then(function (res) {
          if (res.code == '0') {
            that.recommend = res.data;
            that.$nextTick(function () {
              var swiper1 = new Swiper('.banner', {
                pagination: '.swiper-pagination',
                paginationType: 'custom',
                paginationCustomRender: function (swiper, current, total) {
                  var lineWidth = (100 / total) - 0.4;
                  var str = '';
                  for (var i = 0; i < total; i++) {
                    if (i == current - 1) {
                      str += "<span class='spanline-class spanline-active' style='width:" + lineWidth + "%'></span>";
                    } else {
                      str += "<span class='spanline-class' style='width:" + lineWidth + "%'></span>";
                    }
                  }
                  return str;
                },
                paginationClickable: true,
                autoplayDisableOnInteraction: false,
                autoplay: 4000,
                loop: true
              });
              setTimeout(function () {
                var linkpic = Math.ceil($('.linkpic-box').width() / 2);
                $('.linkpic-box').find('img').css('height', linkpic);
                that.linkpic();
              }, 200)

            });
            // 分享微信
            that.$http.get(API.GetShareInfo, {params: {module: 'home'}})
              .then(function (res) {
                if (res.code == 0) {
                  var title = '',
                    desc = '';
                  let metas = $('head').children('meta');
                  if (res.data.share_title) {
                    title = res.data.share_title
                  } else {
                    title = '央视喊你上电视'
                  }
                  if (res.data.share_contents) {
                    desc = res.data.share_contents
                  } else {
                    desc = '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动';
                  }
                  var dataName = {
                    title: title,
                    desc: desc,
                    imgAddress: res.data.share_pic || that.recommend[0].img_path_h5,
                    Retain: '',// 保留
                    url: API.UrlName
                  };
                  that.weixinShare(dataName)
                }
              })
          }

        });
      // 作品展播
      /*
      var indexVideo = {
        activity_id: '0',
        type: 'indexvideo',
        pagesize: '10',
        page: 1
      };
      this.$http.get(API.RecommendFile, {params: indexVideo})
        .then(function (res) {
          if (res.code == '0') {

            that.videosName = Math.floor(res.data.length / 2);
            that.beSelected = res.data;

            that.$nextTick(function () {
              var swiper2 = new Swiper('.show-work', {
                autoplay: 4000,
                loop: true
              });
              // 图片尺寸控制 16:9
              var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
              $('.pic-box').find('img').css({height: picHimg, visibility: 'visible'});
            })

          }
        });
        */
      //首页最新征集
      /*
      var GetActivities = {
        pagesize: '4',
        page: 1,
        progress: 'on',
        version: 2
      };
      this.$http.get(API.GetActivities, {params: GetActivities})
        .then(function (res) {
          if (res.code == '0') {
            that.tablesName = Math.floor(res.data.length / 2);
            that.tables = res.data;
            that.$nextTick(function () {
              var swiperPoll = new Swiper('.show-poll-swiper', {
                loop: true,
                autoplayDisableOnInteraction: false
              });
              // 图片尺寸控制 16:9
              setTimeout(function () {
                var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                $('.pic-box').find('img').css({height: picHimg, visibility: 'visible'});
              }, 200);

            });
          }
        });
      */
      // 正在进行
      this.$http.get(API.GetHomeOnList)
        .then(function (res) {
          if (res.code == '0') {
            for (var i = 0; i < res.data.length; i++) {
              // if (i < 3 && res.data[i].item_id) {
              //   that.underway.push(res.data[i])
              // } else {
              //   that.underway2.push(res.data[i])
              // }
               that.underway.push(res.data[i])
            }
            that.$nextTick(function () {
              var linkpic = Math.ceil($('.linkpic-box').width() / 2);
              $('.linkpic-box').find('img').css('height', linkpic);

            })
          }
        });

    },
    mounted: function () {
      // 操作DOM
      var that = this;

      $(function () {
        $('.index-content').on('click', '.broadcast', function () {
          var item = JSON.parse($(this).attr('attr-item'));
          var type = $(this).attr('attr-type');
          if (type == 'recommend') {
            that.detail(item.url, item.item_id, item.img_path_h5, item.type)
          } else if (type == 'tablesName') {
            that.detail(item.url, item.id, item.img_path, item.type)
          }
        });
        setTimeout(function () {
          // 图片尺寸控制 2:1
          that.linkpic();
        }, 2000)
      })
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/home/index.vue